export default __webpack_public_path__ + "static/media/no_quotation.5f1f2d93.png";